import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

const dataTableInit = {
  dts: {},
  isLoadingDts: false
}

function dataTablesReducer(draft, { type, payload }) {
  switch (type) {
    case "setDts": {
      payload.DataTables.forEach(dt => draft.dts[dt.id] = dt)
      break;
    }

    case "setIsLoadingDts": {
      draft.isLoadingRoles = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [DataTableContext, DataTableDispatchContext] = [
  createContext(null),
  createContext(null),
]

export default function DataTableProvider({ init, children }) {
  const [datatableStore, dispatch] = useImmerReducer(dataTablesReducer, init||dataTableInit);

  return (
    <DataTableContext.Provider value={datatableStore}>
      <DataTableDispatchContext.Provider value={dispatch}>
        {children}
      </DataTableDispatchContext.Provider>
    </DataTableContext.Provider>
  );
}

export function useDataTableStore() {
  return useContext(DataTableContext);
}

export function useDataTableDispatch() {
  return useContext(DataTableDispatchContext);
}